// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3RFF4","list":"PatternAutocomplete_list__2k6xg"};